// ** Router Import
import Router from './router/Router'
import { OnboardingProvider } from './views/forms/wizard/OnboardingContext'
import { QueryClient, QueryClientProvider } from 'react-query'

const queryClient = new QueryClient()

const App = () => {
return (
    <QueryClientProvider client={queryClient}>
      <OnboardingProvider><Router /></OnboardingProvider>
    </QueryClientProvider>
  )
}

export default App
